'use client';

import React, { FC } from 'react';

import PartPageBanner from '@/components/UI/part-page-banner';
import PartServicesDecor from '@/components/UI/part-services-decor';
import { ICategoryPage } from '@/contentful/utils/categoryPage';
import { IDetailes } from '@/contentful/utils/detailes';
import { IForm } from '@/contentful/utils/form';
import { useLanguage } from '@/context/LanguageContext';

import PartContactDetailes from './part-contact-detailes';
import PartMap from './part-map';

import styles from './page-contact.module.scss';

// TODO: remove this after adding data from contentful about Google Maps
interface IPageContactView {
  data: {
    contactPages: ICategoryPage[];
    detailes: IDetailes[];
    forms: IForm[];
  };
}

const PageContactView: FC<IPageContactView> = ({ data }) => {
  const { language } = useLanguage();
  const contactPage = data.contactPages.filter((item) => item.lang === language)[0];

  const contactDetails = data.detailes.filter((item) => item.lang === language)[0];

  const contactForm = data.forms.filter((item) => item.lang === language)[0];

  const contactPageBannerData = {
    title: contactPage.title,
    imageDesktop: contactPage.imageDesktop,
    imageMobile: contactPage.imageMobile,
  };

  const contactDetailsData = {
    category: contactPage.sectionFirstCategory,
    title: contactPage.sectionFirstTitle,
    detailes: contactDetails,
    form: contactForm,
  };

  return (
    <>
      <PartPageBanner data={contactPageBannerData} category />
      <div className={styles.divider} id="order" />
      <PartContactDetailes data={contactDetailsData} />
      <PartMap />
      <PartServicesDecor />
    </>
  );
};

export default PageContactView;
